/* Filtrage local de la liste de valeurs dans une facette verticale.
   Cible : tous les <input data-facet-internal-search> injectés par facets.liquid
   sur Auteur / Éditeur / Collection (et tout filtre > 10 valeurs).
   100% client-side : S&D rend les valeurs au-delà de 10 avec .hidden, on les
   ré-affiche quand elles matchent la recherche. */
(function () {
  'use strict';

  function getLabelText(li) {
    var label = li.querySelector('label');
    if (!label) return '';
    var clone = label.cloneNode(true);
    var svgs = clone.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) svgs[i].remove();
    return clone.textContent.trim().toLowerCase();
  }

  function initInput(input) {
    if (input.dataset.facetInternalInit) return;
    input.dataset.facetInternalInit = '1';

    var fieldset = input.closest('fieldset');
    var ul = fieldset && fieldset.querySelector('ul');
    if (!ul) return;

    function items() { return ul.querySelectorAll('li'); }

    function filter(q) {
      items().forEach(function (li) {
        if (q) {
          var match = getLabelText(li).indexOf(q) !== -1;
          if (match) {
            if (li.classList.contains('hidden')) {
              li.dataset.facetWasHidden = '1';
              li.classList.remove('hidden');
            }
            li.style.display = '';
          } else {
            li.style.display = 'none';
          }
        } else {
          if (li.dataset.facetWasHidden) {
            li.classList.add('hidden');
            delete li.dataset.facetWasHidden;
          }
          li.style.display = '';
        }
      });
      // Empty state
      var visible = Array.prototype.filter.call(items(), function (li) { return li.style.display !== 'none'; });
      var emptyMsg = fieldset.querySelector('.facets__internal-search-empty');
      if (q && visible.length === 0) {
        if (!emptyMsg) {
          emptyMsg = document.createElement('div');
          emptyMsg.className = 'facets__internal-search-empty';
          emptyMsg.textContent = 'Aucun résultat';
          ul.parentNode.insertBefore(emptyMsg, ul.nextSibling);
        }
      } else if (emptyMsg) {
        emptyMsg.remove();
      }
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
      if (e.key === 'Escape') { input.value = ''; filter(''); }
    });
    input.addEventListener('input', function (e) {
      e.stopPropagation();
      var q = this.value.trim().toLowerCase();
      filter(q);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-facet-internal-search]').forEach(initInput);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  // S&D re-rendre la sidebar après filtrage → réinitialiser
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
